"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const agGrid_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/agGrid"));
const package_json_1 = require("../../package.json");
const version_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/version"));
const setupFrameworkComponents_1 = require("../setupFrameworkComponents");
const join_1 = tslib_1.__importDefault(require("../utils/join"));
if (package_json_1.version !== version_1.default) {
    console.warn(`
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
!!!!!!! "@adaptabletools/adaptable-react-aggrid" (v @${package_json_1.version}) and "@adaptabletools/adaptable" (v @${version_1.default}) have different versions - they should have the exact same version.
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
`);
}
const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));
const AdaptableReact = (_a) => {
    var { adaptableOptions, gridOptions, onAdaptableReady } = _a, props = tslib_1.__rest(_a, ["adaptableOptions", "gridOptions", "onAdaptableReady"]);
    const seedId = (0, react_1.useMemo)(() => `${getRandomInt(1000)}-${Date.now()}`, []);
    const adaptableContainerId = `adaptable-${seedId}`;
    const containerRef = (0, react_1.useMemo)(() => {
        let adaptableApi;
        return (node) => {
            if (node) {
                agGrid_1.default.initInternal(Object.assign(Object.assign({}, adaptableOptions), { containerOptions: Object.assign(Object.assign({}, adaptableOptions.containerOptions), { adaptableContainer: node }) }), {
                    gridOptions,
                    waitForAgGrid: true,
                    variant: 'react',
                }).then((api) => {
                    adaptableApi = api;
                    if (onAdaptableReady) {
                        adaptableApi.eventApi.on('AdaptableReady', onAdaptableReady);
                    }
                    (0, setupFrameworkComponents_1.setupFrameworkComponents)(adaptableApi);
                });
            }
            else {
                if (adaptableApi) {
                    adaptableApi.destroy({
                        unmount: true,
                        destroyApi: false,
                    });
                }
                adaptableApi = null;
            }
        };
    }, []);
    return (React.createElement("div", Object.assign({}, props, { ref: containerRef, id: adaptableContainerId, className: (0, join_1.default)(props.className, 'ab__react-wrapper') })));
};
exports.default = AdaptableReact;
